module.exports = __webpack_public_path__ + "static/img/licence.4d56f40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/licence.jpg
// module id = 414
// module chunks = 2